import { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import AddIcon from '@mui/icons-material/Add';
import Inflow from '../Cashflow/InflowPayments';
import Outflow from '../Cashflow/OutflowPayments';
import AddPaymentForm from './DialogAddPaymentForm';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ px: 0, py: 2 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
   
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export default function CashFlowTabs() {
  const [value, setValue] = useState(0);
  const isInflow = value === 0;
  const [openPaymentDrawer, setOpenPaymentDrawer] = useState(false);
  // Bumped after a payment is saved; the visible list re-fetches on the change.
  const [inflowRefresh, setInflowRefresh] = useState(0);
  const [outflowRefresh, setOutflowRefresh] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
  };

  const handleClosePayment = (saved: any) => {
    if (saved) {
      if (isInflow) setInflowRefresh((n) => n + 1);
      else setOutflowRefresh((n) => n + 1);
    }
    setOpenPaymentDrawer(false);
  };

    return (
      <Box sx={{ width: '100%', marginTop:'-10px', marginRight:'-65px' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginRight:'5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Tabs value={value} onChange={handleChange} aria-label="Payments">
            <Tab label="Payment In" {...a11yProps(0)} />
            <Tab label="Payment Out" {...a11yProps(1)} />
          </Tabs>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            size="small"
            disableElevation
            onClick={() => setOpenPaymentDrawer(true)}
            style={{ color: '#fff', backgroundColor: '#059669', height: 35, borderRadius: 7, marginTop: '14px', marginBottom: '8px', textTransform: 'none', fontSize: '14px' }}
          >
            {isInflow ? 'Receive New Payment' : 'Add New Payment'}
          </Button>
        </Box>
        <Drawer
          disableEscapeKeyDown={false}
          anchor="right"
          open={openPaymentDrawer}>
          {<AddPaymentForm isInflow={isInflow} title='Add new payment' open={openPaymentDrawer} onClose={handleClosePayment} />}
        </Drawer>
        <TabPanel value={value} index={0}>
            <Inflow refreshKey={inflowRefresh} onAddPayment={() => setOpenPaymentDrawer(true)} />
        </TabPanel>
        <TabPanel value={value} index={1}>
            <Outflow refreshKey={outflowRefresh} onAddPayment={() => setOpenPaymentDrawer(true)} />
        </TabPanel>
      </Box>
    );
  }
